import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { Reveal } from './Reveal';
import { faqs } from '../data/content';
export function FAQSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-navy-900 py-20 lg:py-24" aria-labelledby="faq-heading" data-id="element-15" data-mp="1nurpm8hz34mb">
      <div className="mx-auto max-w-4xl px-6 lg:px-8" data-id="element-16" data-mp="2bkccv3l5so1e">
        <Reveal data-id="element-17" data-mp="2blnf2yyyhnqe">
          <h2 id="faq-heading" className="text-3xl font-black leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl" data-id="element-18" data-mp="2bl5l68zrnlln">
            Still have questions? We&rsquo;ve got answers.
          </h2>
        </Reveal>

        <div className="mt-12 divide-y divide-white/10 overflow-hidden rounded-2xl border border-white/10 bg-navy-800" data-id="element-19" data-mp="21sq37bogyx0r">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} data-id="element-20" data-mp="2uhdj0rqg8u6x" data-mpi={i}>
                <h3 data-id="element-21" data-mp="2za6ojhtqs6k2">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-start justify-between gap-6 px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-white/[0.04] focus-visible:outline focus-visible:-outline-offset-2 focus-visible:outline-2 focus-visible:outline-brand-gold" data-id="element-22" data-mp="2zaq8t56v7719">
                    <span className="text-[15px] font-bold text-white sm:text-base" data-id="element-23" data-mp="20nt327mcdya0">{faq.q}</span>
                    <PlusIcon aria-hidden="true" className={`mt-0.5 h-5 w-5 shrink-0 text-brand-gold transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-24" data-mp="2fcpbw6w83fbo" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-25" data-mp="2odwyvstagtqg">
                  {isOpen && <motion.div id={`faq-panel-${i}`} key="panel" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-26" data-mp="2jf3sslgc050b">
                      <p className="px-6 pb-6 pr-14 text-[15px] leading-relaxed text-slate-300" data-id="element-27" data-mp="2u4rg0qrx2gpf">{faq.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}